<template>
  <div>
    <LoginHeader></LoginHeader>
    <CenteredLoadingIcon></CenteredLoadingIcon>
  </div>
</template>

<script>
import CenteredLoadingIcon from '../common/CenteredLoadingIcon.vue';
import LoginHeader from '../LoginHeader.vue';

export default {
  components: {
    CenteredLoadingIcon,
    LoginHeader,
  },
  created() {
    const { host, protocol } = window.location;

    this.$auth.loginWithRedirect({
      redirect_uri: `${protocol}//${host}/callback`,
    });
  },
};
</script>

